import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { useParams } from "react-router-dom";
import { clearPaymentDetails } from "./paymentSlice";
import { getPaymentByID } from "./services/payment.services";
import {
  checkAcessRights,
  convertToWords,
  formatIndianNumber,
  getAccountingYear,
} from "../../_helper/helper";
import moment from "moment";
import { PRINT_ACCESS } from "../../_contstants/common";
import { Button } from "@progress/kendo-react-buttons";

const PaymentVoucherPrint: React.FC = () => {
  const dispatch = useAppDispatch();
  const params = useParams();
  const payment_guid = params?.payment_guid;
  const PaymentDetail = useAppSelector((state) => state.payment.PaymentDetail);
  const isPrintAccess = checkAcessRights("/payment", PRINT_ACCESS);

  useEffect(() => {
    if (payment_guid) {
      const handleDriverVisitPrint = async () => {
        const payload = {
          payment_guid: payment_guid,
        };
        const res = await dispatch(getPaymentByID(payload));
        if (res.meta.requestStatus === "fulfilled") {
          window.print();
        }
      };
      handleDriverVisitPrint();
    }
  }, [payment_guid]);

  useEffect(() => {
    return () => {
      dispatch(clearPaymentDetails());
    };
  }, []);

  let totalAmount = 0;

  PaymentDetail?.payment_entry &&
    PaymentDetail?.payment_entry?.length > 0 &&
    PaymentDetail?.payment_entry?.map((payment: any) => {
      return (totalAmount += +payment?.amount);
    });

  return (
    <>
      <div className="container payment-voucher-page">
        <div className="position-relative no-visible-print-btn text-end p-2">
          {isPrintAccess && (
            <Button
              style={{ marginRight: 5 }}
              type="button"
              fillMode={"solid"}
              themeColor={"primary"}
              onClick={() => window.print()}
            >
              Print
            </Button>
          )}
        </div>
        <p className="text-center mb-1">
          <b>Harihar Foods Pvt. Ltd. {getAccountingYear()}</b>
          <br />
          519/1, Nr Ramol Police Chowky
          <br />
          Phase IV, G.I.D.C. Vatva, Ahmedabad 382445
          <br />
          Tel (Off) 079-25841773/25840855 <br />
          FSSAI No: 10012021000359 <br />
          State Name: Gujarat, Code: 24 <br />
          CIN: U15499GJ1994PTC021520 <br />
          E-Mail: marketing@shreeganeshmasala.com
        </p>
        <br />
        <p className="text-center m-0">
          <b>{PaymentDetail?.voucher_type} Pymt Voucher</b>
        </p>
        <div className="d-flex justify-content-between">
          <p className="m-0">
            No.:{" "}
            <span className="fw-bold">{PaymentDetail?.payment_no_string}</span>
          </p>
          <p className="m-0">
            Dated :{" "}
            <span className="fw-bold">
              {PaymentDetail?.payment_date
                ? moment(
                    PaymentDetail?.payment_date,
                    "DD MMM YYYY HH:mm"
                  ).format("DD-MMM-YYYY")
                : ""}
            </span>
          </p>
        </div>
        <table className="drivervisit-print-table">
          <tr
            style={{
              borderTop: "1px solid black",
              borderBottom: "1px solid black",
            }}
          >
            <td style={{ width: "75%" }}>Particulars</td>
            <td
              style={{
                textAlign: "end",
                width: "25%",
                borderLeft: "1px solid black",
              }}
            >
              Amount
            </td>
          </tr>
          <tr>
            <td className="fw-bold">Account :</td>
            <td style={{ borderLeft: "1px solid black" }}></td>
          </tr>
          {PaymentDetail?.payment_entry &&
            PaymentDetail?.payment_entry?.length > 0 &&
            PaymentDetail?.payment_entry?.map((payment: any) => {
              return (
                <tr>
                  <td className="ps-3">{payment.account_name}</td>
                  <td
                    className="fw-bold text-end"
                    style={{ borderLeft: "1px solid black" }}
                  >
                    {formatIndianNumber(payment.amount)}
                  </td>
                </tr>
              );
            })}
          <tr>
            <td className="fw-bold pt-3">Through :</td>
            <td style={{ borderLeft: "1px solid black" }}></td>
          </tr>
          <tr>
            <td className="ps-3">{PaymentDetail?.account_name}</td>
            <td style={{ borderLeft: "1px solid black" }}></td>
          </tr>
          <tr>
            <td className="fw-bold pt-1">On Account of :</td>
            <td style={{ borderLeft: "1px solid black" }}></td>
          </tr>
          {PaymentDetail?.remarks ? (
            <tr>
              <td className="ps-3">{PaymentDetail?.remarks}</td>
              <td style={{ borderLeft: "1px solid black" }}></td>
            </tr>
          ) : null}
          <tr>
            <td className="fw-bold pt-1">Amount (in words) :</td>
            <td style={{ borderLeft: "1px solid black" }}></td>
          </tr>
          <tr>
            <td className="ps-3">{convertToWords(totalAmount || 0)}</td>
            <td style={{ borderLeft: "1px solid black" }}></td>
          </tr>
          <tr>
            <td style={{ borderBottom: "1px solid black" }}></td>
            <td
              className="fw-bold text-end"
              style={{ border: "1px solid black", borderRight: "none" }}
            >
              Rs. {formatIndianNumber(totalAmount || 0)}
            </td>
          </tr>
        </table>
        <div className="row mt-1">
          <div className="col-6">
            <p className="m-0">Receiver’s Signature</p>
          </div>
          <div className="col-6">
            <p className="text-end m-0">Authorised Signatory</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default PaymentVoucherPrint;
